import React, { useState } from "react";
import { Helmet } from "react-helmet";
import "../../../App.css";
import cupImage from "../../../assets/HouseCup.png";
import titleImage from "../../../assets/TitleHouseCup.png";
import HousePoints from "../../housePoints";

const Home = () => {
    const baseURL = window.location.origin;
    const [isZoomed, setIsZoomed] = useState(false);

    return (
        <div className="home-container">
            <Helmet>
                <title>Pogforts - MMM Discord Server</title>
                <meta
                    name="description"
                    content="See current House points and view the current House Cup stats."
                />
                <meta property="og:title" content="House Cup - Big Game Stats" />
                <meta
                    property="og:description"
                    content="See current House points and view the current House Cup stats."
                />
                <meta property="og:image" content={`${baseURL}/assets/PogfortsHome.png`} />
                <meta property="og:url" content={`${baseURL}/house-cup`} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="House Cup - Big Game Stats" />
                <meta
                    name="twitter:description"
                    content="See current House points and view the current House Cup stats."
                />
                <meta name="twitter:image" content={`${baseURL}/assets/PogfortsHome.png`} />
            </Helmet>

            <h1 className="hidden-title">House Cup - Big Game Stats</h1>

            <img src={titleImage} alt="TitleHouseCup" className="featured-image" />

            <img
                src={cupImage}
                alt="HouseCup"
                className="housecup-image"
                onClick={() => setIsZoomed(true)}
            />

            {isZoomed && (
                <div className="zoom-overlay" onClick={() => setIsZoomed(false)}>
                    <img
                        src={cupImage}
                        alt="House Cup Enlarged"
                        className="zoomed-housecup"
                    />
                </div>
            )}

            <div className="chart-container">
                <HousePoints />
            </div>

            <p>Welcome to Pogforts!</p>
        </div>
    );
};

export default Home;